import React from 'react';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { Box } from '@mui/material';
import { UiContext } from 'shared/lib/contexts/uiContext';
import map from 'lodash-es/map';
import EditableTable from 'shared/lib/extendedComponents/tables/editableTable/editableTable';
import TableHeaderItem from 'shared/lib/extendedComponents/tables/tableHeaderItem';
import { TableLinksHelper } from 'entities/table/model/tableLinksHelper';
import ActionInlineButton from 'shared/lib/components/controls/buttons/actionInlineButton';
import EditableTableRow from 'shared/lib/extendedComponents/tables/editableTable/editableTableRow';
import { useTranslation } from 'react-i18next';
import IconCirclePlus from 'shared/icons/iconCirclePlus';

export const useTableHeader = () => {
  const { t } = useTranslation();

  return (
    <tr>
      <th>
        <TableHeaderItem>{t('formFields.projectName')}</TableHeaderItem>
      </th>
      <th>
        <TableHeaderItem>{t('formFields.description')}</TableHeaderItem>
      </th>
      <th>
        <TableHeaderItem>{t('formFields.link')}</TableHeaderItem>
      </th>
    </tr>
  );
};

export default observer(function TableViewController({
  tableHelper,
}: {
  tableHelper: TableLinksHelper;
}) {
  const { t } = useTranslation();
  const {
    spacings: { sp },
  } = useContext(UiContext);

  const header = useTableHeader();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: sp.s60 }}>
      <EditableTable>
        {header}

        {map(tableHelper.linksArray, (linkData) => {
          const item = tableHelper.getById(linkData.id);

          return item ? (
            <EditableTableRow
              key={item.id}
              item={item}
              onDelete={() => tableHelper.deleteRow(item.id)}
              isDeleteDisabled={tableHelper.isLastRow}
              shouldHighlightValidation={tableHelper.isSubmitError}
            ></EditableTableRow>
          ) : null;
        })}
      </EditableTable>
      <ActionInlineButton
        sizeVariant="small"
        Icon={IconCirclePlus}
        disabled={tableHelper.isSomeNotFilled}
        onClick={() => tableHelper.createEmpty()}
      >
        {t('common.addLine')}
      </ActionInlineButton>
    </Box>
  );
});
